import { computed, ref } from "@vue/composition-api";

export default function usePromisesStack() {
  const promises = ref<Promise<void>[]>([]);
  const loading = computed(() => !!promises.value.length);

  const pendingAllResolve = async () => {
    try {
      await Promise.all(promises.value);
    } finally {
      promises.value = [];
    }
  };

  const executeAsyncAfterAll = async (cb: () => Promise<void>) => {
    await pendingAllResolve();
    promises.value = [cb()];
    await pendingAllResolve();
  };

  const executeAfterAll = async (cb: () => void) => {
    await pendingAllResolve();
    cb();
  };

  return {
    loading,
    executeAfterAll,
    executeAsyncAfterAll,
  };
}
